import { Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import { ToastContainer } from "react-toastify";
import { AuthenticationServiceProvider } from "../services/authentication.service";
import { CentreBankingServiceProvider } from "../pages/centreBanking/contexts/CentreBankingServiceContext";
import { MasterLayout } from ".";
import { PrivateRoute } from "../components";
import roles from "../utils/constants/roles";

// Lazy load pages for better performance
const Login = lazy(() => import("../pages/login"));
const NotFoundPage = lazy(() => import("../pages/error/not.found"));
const LandingPage = lazy(() => import("../pages/landing"));
const UploadPage = lazy(() => import("../pages/upload"));
const BankFilesPage = lazy(() => import("../pages/bankFiles"));
const ExportPage = lazy(() => import("../pages/export"));
const ChildMatchPage = lazy(() => import("../pages/childMatch"));
const TransactionPage = lazy(() => import("../pages/transactions"));
const CentresPage = lazy(() => import("../pages/centres"));
const FinancePage = lazy(() => import("../pages/finance"));
const BankingReportPage = lazy(() => import("../pages/bankingReport"));
const CentreBanking = lazy(() => import("../pages/centreBanking"));

export default function ProviderLayout() {
  return (
    <AuthenticationServiceProvider>
      <ToastContainer />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/login" element={<Login />}></Route>
          <Route
            path="/"
            element={
              <PrivateRoute roles={roles.ALL_ROLES}>
                <MasterLayout />
              </PrivateRoute>
            }
          >
            <Route
              index
              element={
                <PrivateRoute roles={roles.ALL_ROLES}>
                  <LandingPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/upload"
              element={
                <PrivateRoute roles={roles.ADMINS}>
                  <UploadPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/bank-files"
              element={
                <PrivateRoute roles={roles.ADMINS}>
                  <BankFilesPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/export"
              element={
                <PrivateRoute roles={roles.ADMINS}>
                  <ExportPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/child-match"
              element={
                <PrivateRoute roles={roles.ADMINS}>
                  <ChildMatchPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/transactions"
              element={
                <PrivateRoute roles={[...roles.SUPPORT, roles.ROLE_FINANCE]}>
                  <TransactionPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/centres"
              element={
                <PrivateRoute roles={roles.ADMINS}>
                  <CentresPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/finance"
              element={
                <PrivateRoute roles={[...roles.FINANCE, ...roles.ADMINS]}>
                  <FinancePage />
                </PrivateRoute>
              }
            />
            <Route
              path="/banking-report"
              element={
                <PrivateRoute roles={roles.CENTRE_ADMIN}>
                  <BankingReportPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/centre-banking/:centreId?"
              element={
                <PrivateRoute roles={roles.CENTRE_ADMIN}>
                  <CentreBankingServiceProvider>
                    <CentreBanking />
                  </CentreBankingServiceProvider>
                </PrivateRoute>
              }
            />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </AuthenticationServiceProvider>
  );
}
